import Chat from "../../compoenents/Chat";
import { Outlet, Link, router, useParams, useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef, useMemo } from "react";

import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheck/page";
import { API, ApiAdmin, MAPS_API_KEY } from "../../Values";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import axios from "axios";

const mapContainerStyle = {
  width: "100%",
  height: "100%",
};

const center = {
  lat: 30.033, // الموقع الافتراضي
  lng: 31.233,
};
export default function TawseelMashweer(Search) {
  const params = useParams();
  const [deliveryLocation, setDeliveryLocation] = useState(center);
  const [deliveryName, setDeliveryName] = useState("");
  const [isLoaded, setIsLoaded] = useState(false); // حالة تحميل الخريطة
  const [pickupLocation, setPickupLocation] = useState([]); // نقطة الاستلام
  const [pickupName, setPickupName] = useState("");

  const [distance, setDistance] = useState("0"); // المسافة بين نقطتي الاستلام والتسليم
  const [Distance_ok, setDistance_ok] = useState("0"); // المسافة بين نقطتي الاستلام والتسليم

  const [currentLocation, setCurrentLocation] = useState(null); // الموقع الحالي للمستخدم
  const [map, setMap] = useState(null);
  const searchInputRef = useRef();
  const autocompleteRef = useRef();
  const navigate = useNavigate();
  const libraries = useMemo(() => ["places", "geometry"], []);
  const [isLoading, setIsLoading] = useState(true);
  const [logo, Setlogo] = useState("");
  const [Errors, SetErrors] = useState("");
  //---------ShowModalErrors----------------------------
  const [ModalError, SetModalError] = useState(false);
  const handleCloseModalError = () => SetModalError(false);
  const handleShowModalError = () => SetModalError(true);
  const [Cost, SetCost] = useState([]);
  LoginCheck();
  var userinfo = [];
  var Username = "";
  var CustomerID = "";
  var City = "";
  var State = "";
  var Address = "";
  var Mobail = "";
  if (Cookies.get("userinfo")) {
    userinfo = JSON.parse(Cookies.get("userinfo"));
    Username = userinfo[0].Name;
    CustomerID = userinfo[0].ID;
    City = userinfo[0].City;
    State = userinfo[0].State;
    Address = userinfo[0].Address;
    Mobail = userinfo[0].Mobail;
  }




  const [MAPS_API_KEY_, SET_MAPS_API_KEY] = useState(MAPS_API_KEY);
  useEffect(() => {
    GetApiKey();
  }, []);
  async function GetApiKey() {
    try {
      const type = "Google Maps";
      const post = {
        type: type,
        Action: "GetApiType",
      };
      const response = await fetch(ApiAdmin + "/Api_Setting.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      console.log("============  get api ===============");
      // console.log(data[0].token);
      SET_MAPS_API_KEY(data[0].token);
    } catch (error) {
      return error;
    }
  }
  //--------------------------------------
  useEffect(() => {
    if (params.type == "سائق سيارة") {
      Setlogo("../car.jpg");
    }
    if (params.type == "سائق متوسيكل") {
      Setlogo("../motosekl0.jpg");
    }
    if (params.type == "نقل ثقيل") {
      Setlogo("../nkl.jpg");
    }


  }, []);
  //=============================================

  useEffect(() => {
    GetMyLocation();
  }, []);

  function GetMyLocation() {
    const savedCurentLocation = JSON.parse(
      localStorage.getItem("CurentLocation")
    );
    if (savedCurentLocation) {
      setPickupLocation(savedCurentLocation.location);
      setPickupName(savedCurentLocation.name);
      setDeliveryLocation(savedCurentLocation.location);
      setDeliveryName(savedCurentLocation.name);
      //  getPlaceName(savedCurentLocation.location.lat, savedCurentLocation.location.lng);
      setDistance("0");
      CalculateCost("0");
      //setIsLoading(false);

    }
    console.log("CurentLocation");
    console.log(savedCurentLocation);
  }

  //==============================================
  useEffect(() => {
    if (window.google && window.google.maps) {
      const input = searchInputRef.current;
      //const autocomplete00 = new window.google.maps.places.PlaceAutocompleteElement(input, {fields: ["place_id", "geometry", "name"],});
      const autocomplete = new window.google.maps.places.Autocomplete(input);
      autocompleteRef.current = autocomplete;
      // عند تحديد مكان من الـ  Autocomplete
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place.geometry) {
          const location = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };
          setDeliveryLocation(location);
          getPlaceName(location.lat, location.lng);
          console.log(location);
          console.log(pickupLocation);
          // حساب المسافة بين نقطتي الاستلام والتسليم
          if (pickupLocation) {
            calculateDistance(pickupLocation, location);
          }
          // تحريك الخريطة إلى الموقع المحدد
          if (map) {
            map.panTo(location); // تحريك الخريطة إلى المكان المحدد
            map.setZoom(14); // تحديد مستوى التكبير عند النقطة
          }
        }
      });
    }
  }, [map]);


  const handleMapClick = async (event) => {
    const latLng = event.latLng;
    const location = {
      lat: latLng.lat(),
      lng: latLng.lng(),
    };
    setDeliveryLocation(location);
    getPlaceName(location.lat, location.lng);
    console.log(pickupLocation);
    // حساب المسافة بين نقطتي الاستلام والتسليم
    if (pickupLocation) {
      calculateDistance(pickupLocation, location);
    }
    // تحريك الخريطة إلى الموقع المحدد
    if (map) {
      map.panTo(location); // تحريك الخريطة إلى المكان المحدد
      map.setZoom(14); // تحديد مستوى التكبير عند النقطة
    }
  };


  const getPlaceName = async (latitude, longitude) => {
    try {
      const location = {
        lat: latitude,
        lng: longitude,
      };
      const response = await axios.get(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json&accept-language=ar`);
      setDeliveryLocation(location);
      setDeliveryName(response.data.display_name);
      setIsLoading(false);
      console.log(location);
      console.log(response.data.display_name);

      if (pickupLocation) {
        calculateDistance(pickupLocation, location);
      }

    } catch (error) {
      console.error('خطأ في جلب اسم الموقع:', error);
    }
  };

  const getPlaceName0 = (lat, lng) => {
    const location = {
      lat: lat,
      lng: lng,
    };
    const geocoder = new window.google.maps.Geocoder();
    const latLng = new window.google.maps.LatLng(lat, lng);
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results[0]) {
        setDeliveryName(results[0].formatted_address);
        // setDeliveryLocation(location);
        // localStorage.setItem(
        //   "deliveryLocation",
        //   JSON.stringify({ location, name: results[0].formatted_address })
        // );
      }
    });
  };

  // دالة حساب المسافة بين نقطتين
  const calculateDistance = (pickup, delivery) => {
    const R = 6371e3; // نصف قطر الأرض بالأمتار
    const φ1 = (pickup.lat * Math.PI) / 180; // تحويل درجة العرض الأولى إلى راديان
    const φ2 = (delivery.lat * Math.PI) / 180; // تحويل درجة العرض الثانية إلى راديان
    const Δφ = ((delivery.lat - pickup.lat) * Math.PI) / 180; // فرق العرض بالراديان
    const Δλ = ((delivery.lng - pickup.lng) * Math.PI) / 180; // فرق الطول بالراديان

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distanceInMeters = R * c; // المسافة بالأمتار
    const distanceInKilometers = distanceInMeters / 1000; // المسافة بالكيلومترات

    // تحديد الوحدات وعرض النتيجة
    let result;
    if (distanceInKilometers >= 1) {
      result = `${distanceInKilometers.toFixed(2)} كم`; // إذا كانت المسافة بالكيلومترات
    } else {
      result = `${distanceInMeters.toFixed(0)} م`; // إذا كانت المسافة بالأمتار
    }

    console.log("Distance: " + result);
    setDistance(result); // تخزين المسافة
    CalculateCost(result);
    // حفظ اdistance__لبيانات في localStorage
    localStorage.setItem("distance", JSON.stringify({ distance: result }));
    return result; // النتيجة مع الوحدات
  };
  //=========================================================================
  //=========================================================================
  const calculateDistance0 = (pickup, delivery) => {
    const service = new window.google.maps.DistanceMatrixService();
    // const pickup = convertArabicNumbersToEnglish(pickup_);
    // const delivery = convertArabicNumbersToEnglish(delivery_);
    service.getDistanceMatrix(
      {
        origins: [pickup],
        destinations: [delivery],
        travelMode: window.google.maps.TravelMode.DRIVING,
        unitSystem: window.google.maps.UnitSystem.METRIC,
      },
      (response, status) => {
        if (status === "OK") {
          const distance_ = response.rows[0].elements[0].distance.text;

          // const distance__ = convertArabicNumbersToEnglish(distance_);

          setDistance(distance_); // تخزين المسافة
          // حفظ اdistance__لبيانات في localStorage
          localStorage.setItem(
            "distance",
            JSON.stringify({ distance: distance_ })
          );
        } else {
          alert("حدث خطأ أثناء حساب المسافة.");
        }
      }
    );
  };
  //----------------------------------------
  const convertArabicNumbersToEnglish = (input) => {
    if (!input) return "";

    // استبدال الأرقام
    const arabicToEnglishMap = {
      "٠": "0",
      "١": "1",
      "٢": "2",
      "٣": "3",
      "٤": "4",
      "٥": "5",
      "٦": "6",
      "٧": "7",
      "٨": "8",
      "٩": "9",
    };

    // تحويل الأرقام والفواصل
    return input
      .replace(/[٠-٩]/g, (digit) => arabicToEnglishMap[digit]) // استبدال الأرقام
      .replace(/،/g, ","); // استبدال الفاصلة
  };

  // تحميل الخريطة وتغيير حالة isLoaded عند الانتهاء
  const handleLoad = () => {
    setIsLoaded(true); // الخريطة أصبحت جاهزة
  };
  //=============================================
  //-------------------------------------------------------------

  async function CalculateCost(distance_) {
    try {
      const post = {
        Action: "CalculateDestanse",
        Distance: convertArabicNumbersToEnglish(distance_),
        KobonDescount: "0",
        service: params.type,
      };
      //console.log(post);
      const response = await fetch(ApiAdmin + "/Destanse.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      console.log("cost");
      console.log(data);
      SetCost(data);
    } catch (error) {
      return error;
    }
  }
  //====================================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());
    // return alert("سيتم تغعيل الخدمة قريبا");
    if (data_.Distance == "0") {
      return alert("الرجاء اختيار المكان المراد التوجه الية");
    }
    // return console.log(data_);
    try {
      const response = await fetch(API.Orders, {
        method: "POST",
        body: JSON.stringify(data_),
      });
      const data = await response.json();

      if (data.errors != "") {
        SetErrors(data.errors);
        handleShowModalError();
      }

      if (data.msg == "success") {
        localStorage.removeItem("pickupLocation");
        localStorage.removeItem("distance");
        localStorage.removeItem("deliveryLocation");
        return navigate(`../Customer/OrderWaiting/${data.number_order}/0`);
        SetErrors(data.msg);
        handleShowModalError();
      }
      if (response.ok) {
      } else if (response.status === 400) {
        return alert("Errorr 400");
      } else {
        return alert("Can Not Save ");
      }
    } catch (error) {
      console.log(error);
    }
  };




  //-----------------------------------------

  const imgstyle = {
    height: "100%",
  };



  return (
    <>

      <form method="POST" onSubmit={handleSubmit}>
        <input type="hidden" name="Action" value="NewOrder" />
        <input type="hidden" name="service" value={params.type} />
        <input type="hidden" name="TypeOrder" value={params.type} />
        <input type="hidden" name="CustomerID" value={CustomerID} />
        <input type="hidden" name="CustomerName" value={Username} />
        <input type="hidden" name="City" value={City} />
        <input type="hidden" name="State" value={State} />
        <input type="hidden" name="Address" value={Address} />
        <input type="hidden" name="Mobail" value={Mobail} />
        <input type="hidden" name="logo" value={logo} />

        <input type="hidden" name="from_latitude" value={pickupLocation.lat} />
        <input type="hidden" name="from_longitude" value={pickupLocation.lng} />
        <input type="hidden" name="From" value={pickupName} />
        <input type="hidden" name="to_latitude" value={deliveryLocation.lat} />
        <input type="hidden" name="to_longitude" value={deliveryLocation.lng} />
        <input type="hidden" name="To" value={deliveryName} />
        <input type="hidden" name="Distance" value={distance} />
        <input type="hidden" name="Distance_" value={convertArabicNumbersToEnglish(distance)} />
        <input type="hidden" name="Distance_ok" value={`${Cost.Distance}`} />
        <input type="hidden" name="Description" value={""} />
        <input type="hidden" name="DelevaryPrice" value={Cost.PRICE_TOTAL} />
        <input type="hidden" name="delevary_price_" value={`${Cost.delevary_price}`} />
        <input type="hidden" name="nesba_company" value={`${Cost.nesba_company}`} />
        <input type="hidden" name="descount" value={`${Cost.descount}`} />
        <input type="hidden" name="total" value={`${Cost.total}`} />
        <input type="hidden" name="tax" value={`${Cost.tax}`} />
        <input type="hidden" name="safee" value={`${Cost.safee}`} />
        <input type="hidden" name="Rassed" value="0" />
        <input type="hidden" name="Items" value="توصيل" />
        <input type="hidden" name="KobonCod" value={""} />
        <input type="hidden" name="KobonDescount" value={"0"} />

        <div
          className=" row p-1 text-center m-auto  bg-light "
          style={{ maxWidth: "500px" }}
        >

          <div className="col-12 p-0 px-2 text-center bg-light0">
            <div className="row bg-white p-2 text-end fw-bold m-0 mt-1" style={{ borderRadius: "20px" }}>
              <div className="col-6" >
                <span>هدفنا خدمتك وراحتك!</span><br />
                <span className="text-orange">   جى سيو اكسبريس</span>
              </div>
              <div className="col-5">
                {params.type == "سائق سيارة" && <img src="../../../Images/car.jpg" alt="" style={{ width: "80px" }} />}
                {params.type == "سائق متوسيكل" && <img src="../../../Images/moto.jpg" alt="" style={{ width: "80px" }} />}
                {params.type == "نقل ثقيل" && <img src="../../../Images/nkl2.jpg" alt="" style={{ width: "80px" }} />}

              </div>
              <div className="col-1">
                <Link to="../Customer/Shopping" className="float-start mt-2">
                  <i className="fa-solid fa-xmark  fs-4 "></i>
                </Link>
              </div>
            </div>
            <h4 className="text-end">  الى اين ؟ </h4>
            <div className=" m-1 mb-1">
              <input
                type="text"
                id="pickup-search"
                placeholder="ابحث فى الخريطة"
                ref={searchInputRef}
                style={{ width: "100%", padding: "10px" }}
                className="searchText"
              />
            </div>
          </div>
          <div className="col-12 div-mapTo0 bg-light mb-2 text-end p-0 m-0" style={{ height: "40vh" }}>

            <LoadScript
              googleMapsApiKey={MAPS_API_KEY_}
              libraries={libraries}
              onLoad={handleLoad} // تعيين isLoaded على true بعد تحميل المكتبة
            >
              {isLoaded ? (
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={deliveryLocation}
                  zoom={15}
                  onClick={handleMapClick} // عند النقر على الخريطة
                  onLoad={(mapInstance) => setMap(mapInstance)} // عندما يتم تحميل الخريطة
                >
                  {pickupLocation && (
                    <Marker position={pickupLocation} label="بداية" />
                  )}
                  {deliveryLocation && (
                    <Marker position={deliveryLocation} label="نهاية" />
                  )}
                </GoogleMap>
              ) : (
                <div>الخريطة في مرحلة التحميل... يرجى الانتظار</div> // عرض رسالة مخصصة عند تحميل الخريطة
              )}
            </LoadScript>
          </div>
          <div className="col-12 p-0">
            <div className="w-100 h-100 bg-white0 bg-greenLight text-end p-1" style={{ borderRadius: "10px" }}>
              <i className="fa-solid fa-location-dot text-green  mx-1"> من : </i>
              <small>{pickupName}</small>
              <br />
              <i className="fa-solid fa-location text-green  mx-1"> الى : </i>
              <small>{deliveryName}</small>
              <br />
              <i className="fa-solid fa-meteor text-green  mx-1"> المسافة : </i>
              <span>{distance}</span>
            </div>
          </div>


          <div className="col-12 bg-gray px-3 py-2 text-end mt-2">
            <span className="fw-bold">تكلفة التوصيل</span>
            <span className="float-start mx-1 fw-bold">{distance == "0" ? "0" : Cost.safee} جنية</span>
            <br />
            <small className="text-secondary"> سعر التوصيل  يعتمد على المسافة بين موقع بداية و نهاية الرحلة </small>
          </div>

          <div className="col-12 p-2 pt-0 text-end mb-4">
            <label style={{ fontSize: "13px" }} className="col-form-label fw-bold">
              {"طريقة الدفع "}
            </label>
            <select
              name="PaymentType"
              className="form-control bg-light "
            >
              <option value=""></option>
              <option value="كاش">كاش</option>
              <option value="بطاقة بنكية">بطاقة بنكية</option>
            </select>
            <br /><br /><br />
          </div>

        </div>

        <div className="row buttom-div p-1 bg-white">

          <div className="col-12 text-center pt-2 mb-2">
            <button
              className="btn btn-green w-75 p-2 fw-bold radius"
              style={{ borderRadius: "50px" }}
            >
              ارسل الطلب
            </button>
          </div>
        </div>
      </form>
    </>
  );
}
